<template>
  <div class="pa-10">
    <title-page icon="mdi-shape">{{ isEdit ? $t('organization.sub-perimeter.edit') : $t('organization.sub-perimeter.add') }}</title-page>
    <v-form ref="form" @submit.prevent="save">
      <v-row>
        <v-col cols="12" md="6">
          <form-field :label="$t('code')" v-model="form.code" :rules="[commonRules.required]" />
          <form-field :label="$t('name')" v-model="form.name" type="localized-string" :rules="[commonRules.required]" />
          <form-field
              type="select"
            v-model="form.perimeters"
            :items="perimeterItems"
            :label="$tc('organization.perimeter.perimeter', 2)"
            multiple
            chips
            item-text="name"
            item-value="id"
          />
        </v-col>
      </v-row>


      <v-row class="mt-6">
        <v-col class="text-center">
          <v-btn type="submit" color="primary">{{ $t('save') }}</v-btn>
          <v-btn class="ml-2" @click="cancel">{{ $t('cancel') }}</v-btn>
         </v-col>
      </v-row>
      <v-row class="mt-12">
        <v-col class="text-center">
          <v-btn small outlined color="red" v-if="isEdit" class="ml-2" @click="deleteItem">{{ $t('delete') }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import RulesMixin from "@mixins/RulesMixin";
import OrganizationPerimeterRepository from "@repository/OrganizationPerimeterRepository";

export default {
  data() {
    return {
      form: {
        code: null,
        name: null,
        perimeters: [],
      },
      perimeterItems: [],
    }
  },
  mixins: [RulesMixin],
  computed: {
    id() { return this.$route.params.id || null },
    isEdit() { return !!this.id }
  },
  mounted() {
    // Load perimeters list to allow selecting links
    OrganizationPerimeterRepository.searchPerimeters(null, 0, 1000, 'name', 'asc').then(res => {
      // Expect items like {id, code, name}
      this.perimeterItems = (res.items || []).map(it => ({
        id: it.id,
        name: this.localizedString ? this.localizedString(it.name) || it.name : it.name,
      }))
    }).catch(() => {})

    if (this.isEdit) {
      this.showLoading(true)
      OrganizationPerimeterRepository.getSubPerimeter(this.id).then(result => {
        this.form = {
          code: result.code || null,
          name: result.name || null,
          perimeters: (result.perimeters || []).map(p => typeof p === 'string' ? p : p.id || p),
        }
        this.$nextTick(() => this.cleanUnsavedChanges())
        this.showLoading(false)
      }).catch(err => {
        this.showLoading(false)
        this.notifyError(err)
      })
    }
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'organization-sub-perimeter' })
    },
    save() {
      if (!this.$refs.form.validate()) return
      this.showLoading(true)
      const payload = { ...this.form }
      // Ensure perimeters is array of IDs (backend expects OrganizationPerimeterId[])
      payload.perimeters = (payload.perimeters || []).map(id => id)
      if (this.isEdit) {
        OrganizationPerimeterRepository.updateSubPerimeter(this.id, payload)
          .then(() => {
            this.$dialog.notify.success(this.$t('update-success'))
            this.showLoading(false)
            this.$router.back()
          }).catch(err => {
            this.showLoading(false)
            this.notifyError(err)
          })
      } else {
        OrganizationPerimeterRepository.createSubPerimeter(payload)
          .then(() => {
            this.$dialog.notify.success(this.$t('created-successfully'))
            this.showLoading(false)
            this.$router.back()
          }).catch(err => {
            this.showLoading(false)
            this.notifyError(err)
          })
      }
    },
    deleteItem() {
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if (!result) return
        this.showLoading(true)
        OrganizationPerimeterRepository.deleteSubPerimeter(this.id)
          .then(() => {
            this.$dialog.notify.success(this.$t('delete-success'))
            this.showLoading(false)
            this.$router.back()
          }).catch(err => {
            this.showLoading(false)
            this.notifyError(err)
          })
      })
    }
  }
}
</script>
